import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';
import { ScrollViewProps } from './ScrollViewProps';

export const ScrollView: FunctionComponent<PropsWithChildren<ScrollViewProps>> = ({ className, children }) => {
  return <div className={classNames('overflow-y-auto', className)}>{children}</div>;
};
